import { createRootRoute, createRoute, createRouter, redirect } from '@tanstack/react-router';
import { Home } from '@/containers';

// Create root route
const rootRoute = createRootRoute();

// Create index route
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: Home,
});

// Route to handle /index.html redirect
const indexHtmlRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/index.html',
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});

// Catch-all route for 404 - redirects to home
const notFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '*',
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});

// Create route tree
const routeTree = rootRoute.addChildren([indexRoute, indexHtmlRoute, notFoundRoute]);

// Create router instance
export const router = createRouter({ routeTree });
